import gql from "graphql-tag";

const FLEET_KM_REPORT_EXPORT = gql`
  query FleetKmReportExport(
    $data: [FleetKmReportInput]
    $fechaInicio: Datetime
    $fechaFin: Datetime
    $format: FormatEnum
  ) {
    fleetKmReportExportV2(
      data: $data
      fechaInicio: $fechaInicio
      fechaFin: $fechaFin
      format: $format
    )
  }
`;

export default FLEET_KM_REPORT_EXPORT;
